// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewReceipt-space1-ULsBZ {
	margin-bottom: 6px !important;
}

.ViewReceipt-space2-j6ZYC {
	margin-bottom: 12px !important;
}

.ViewReceipt-space3-I705b {
	margin-bottom: 18px !important;
}

.ViewReceipt-space4-VW9bZ {
	margin-bottom: 24px !important;
}

.ViewReceipt-space5-spBAm {
	margin-bottom: 30px !important;
}

.ViewReceipt-space6-__ADJ {
	margin-bottom: 36px !important;
}

.ViewReceipt-space7-OuJiB {
	margin-bottom: 42px !important;
}

.ViewReceipt-space8-BC5hJ {
	margin-bottom: 48px !important;
}

.ViewReceipt-spaceTop1-gIR0Y {
	margin-top: 6px !important;
}

.ViewReceipt-spaceTop2-FGLKo {
	margin-top: 12px !important;
}

.ViewReceipt-spaceTop3-eqwg7 {
	margin-top: 18px !important;
}

.ViewReceipt-spaceTop4-V7hPH {
	margin-top: 24px !important;
}

.ViewReceipt-spaceTop5-uUsy5 {
	margin-top: 30px !important;
}

.ViewReceipt-spaceTop6-aIxlf {
	margin-top: 36px !important;
}

.ViewReceipt-spaceTop7-rX73e {
	margin-top: 42px !important;
}

.ViewReceipt-spaceTop8-EYPy7 {
	margin-top: 48px !important;
}

.ViewReceipt-noMargin-G0h8J {
	margin: 0px !important;
}

.ViewReceipt-padding1-GSwT_ {
	padding-bottom: 6px !important;
}

.ViewReceipt-padding2-J3jqg {
	padding-bottom: 12px !important;
}

.ViewReceipt-padding3-WsnF9 {
	padding-bottom: 18px !important;
}

.ViewReceipt-padding4-BruGs {
	padding-bottom: 24px !important;
}

.ViewReceipt-padding5-NH0L8 {
	padding-bottom: 30px !important;
}

.ViewReceipt-padding6-lTel1 {
	padding-bottom: 36px !important;
}

.ViewReceipt-padding7-iKJJy {
	padding-bottom: 42px !important;
}

.ViewReceipt-paddingTop1-AQoz8 {
	padding-top: 6px !important;
}

.ViewReceipt-paddingTop2-bDXEa {
	padding-top: 12px !important;
}

.ViewReceipt-paddingTop3-xzqAi {
	padding-top: 18px !important;
}

.ViewReceipt-paddingTop4-Y0oWT {
	padding-top: 24px !important;
}

.ViewReceipt-paddingTop5-fFmJK {
	padding-top: 30px !important;
}

.ViewReceipt-paddingTop6-z124D {
	padding-top: 36px !important;
}

.ViewReceipt-paddingTop7-nFLyr {
	padding-top: 42px !important;
}

.ViewReceipt-noPadding-sXQG1 {
	padding: 0px !important;
}

.ViewReceipt-spaceMarginBottom0-hFsxv {
	margin-bottom: 0;
}

.ViewReceipt-textBold-OC5qg {
	font-weight: 500 !important;
}

.ViewReceipt-textBolder-i_1qg {
	font-weight: 700 !important;
}

.ViewReceipt-textNormal-jQ7Id {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ViewReceipt-textDarkBlue-aPXlL {
	color: rgb(20, 39, 94) !important;
}

.ViewReceipt-textLightBlue-HjCvg {
	color: rgb(57, 87, 106) !important;
}

.ViewReceipt-textLightSandleGreen-QmdjG {
	color: rgb(76, 86, 41) !important;
}

.ViewReceipt-textLightBrown-iVPu6 {
	color: rgb(115, 79, 33) !important;
}

.ViewReceipt-textMediumMaroon-PslEo {
	color: rgb(87, 37, 51) !important;
}

.ViewReceipt-textBrown-Mtbuq {
	color: rgb(160, 47, 24) !important;
}

.ViewReceipt-textMaroon-BkBYD {
	color: rgb(155, 49, 67) !important;
}

.ViewReceipt-textDarkBrown-yYMG4 {
	color: rgb(83, 18, 16) !important;
}

.ViewReceipt-textMediumBrown-dsrO8 {
	color: rgb(142, 28, 10) !important;
}

.ViewReceipt-textSkyBlue-NgJ9Y {
	color: rgb(37, 117, 141) !important;
}

.ViewReceipt-textGray-SgI4Q {
	color: rgb(77, 65, 51) !important;
}

.ViewReceipt-errorMessage-QgnSe {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ViewReceipt-userText-YYRTu {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ViewReceipt-panelHeader-xFEeZ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ViewReceipt-exportSection-DKfKb {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ViewReceipt-exportSectionGridSub-gdu28 {
	grid-template-columns: 50% 49% !important;
}

.ViewReceipt-exportText-Ed4Fm {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ViewReceipt-exportLinkImg-IjJNY {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ViewReceipt-exportImg-Pk2gr {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ViewReceipt-linkBtn-OEmXa {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ViewReceipt-table-a2hBT {
	display: table;
}

.ViewReceipt-tableRow-OGJ3K {
	display: table-row;
}

.ViewReceipt-tableCell-C5a4R {
	display: table-cell;
	float: none;
}

.ViewReceipt-formGroup-Om9TM {
	margin-bottom: 6px;
}

.ViewReceipt-marginTop0-eASki {
	margin-top: 0;
}

.ViewReceipt-marginBottom20-bGsT2 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ViewReceipt-bannerImageBg-EACVx {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ViewReceipt-bannerDelete-pqr7L {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ViewReceipt-exportLink-tO6zt {
	padding-top: 10px;
	padding-right: 10px;
}

.ViewReceipt-seachContent-_63mn {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ViewReceipt-marginBottom9-QWU6w {
	margin-bottom: 9px;
}

.ViewReceipt-spaceTop52-GdoGM {
	margin-top: 52px;
}

.ViewReceipt-profileViewInner-Aw5fD {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ViewReceipt-profileViewMain-hawGp {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ViewReceipt-profileViewlabel-Wu5G1 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ViewReceipt-profileViewMainContent-rMIvn {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ViewReceipt-reviewsFormStar-oxp2Y {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ViewReceipt-reviewsFormStar-oxp2Y svg {
	cursor: pointer;
}

.ViewReceipt-addLanguageText-XXzPo {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ViewReceipt-exportSection-DKfKb {
		grid-template-columns: 100%;
	}

	.ViewReceipt-spaceTop52-GdoGM {
		margin-top: 18px;
	}

	.ViewReceipt-exportText-Ed4Fm {
		float: none;
		margin-top: 12px;
	}

	.ViewReceipt-exportSectionGridSub-gdu28 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ViewReceipt-profileViewlabel-Wu5G1 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ViewReceipt-profileViewMainContent-rMIvn {
		width: 100%;
		text-align: center;
	}

	.ViewReceipt-panelHeader-xFEeZ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ViewReceipt-space1-ULsBZ`,
	"space2": `ViewReceipt-space2-j6ZYC`,
	"space3": `ViewReceipt-space3-I705b`,
	"space4": `ViewReceipt-space4-VW9bZ`,
	"space5": `ViewReceipt-space5-spBAm`,
	"space6": `ViewReceipt-space6-__ADJ`,
	"space7": `ViewReceipt-space7-OuJiB`,
	"space8": `ViewReceipt-space8-BC5hJ`,
	"spaceTop1": `ViewReceipt-spaceTop1-gIR0Y`,
	"spaceTop2": `ViewReceipt-spaceTop2-FGLKo`,
	"spaceTop3": `ViewReceipt-spaceTop3-eqwg7`,
	"spaceTop4": `ViewReceipt-spaceTop4-V7hPH`,
	"spaceTop5": `ViewReceipt-spaceTop5-uUsy5`,
	"spaceTop6": `ViewReceipt-spaceTop6-aIxlf`,
	"spaceTop7": `ViewReceipt-spaceTop7-rX73e`,
	"spaceTop8": `ViewReceipt-spaceTop8-EYPy7`,
	"noMargin": `ViewReceipt-noMargin-G0h8J`,
	"padding1": `ViewReceipt-padding1-GSwT_`,
	"padding2": `ViewReceipt-padding2-J3jqg`,
	"padding3": `ViewReceipt-padding3-WsnF9`,
	"padding4": `ViewReceipt-padding4-BruGs`,
	"padding5": `ViewReceipt-padding5-NH0L8`,
	"padding6": `ViewReceipt-padding6-lTel1`,
	"padding7": `ViewReceipt-padding7-iKJJy`,
	"paddingTop1": `ViewReceipt-paddingTop1-AQoz8`,
	"paddingTop2": `ViewReceipt-paddingTop2-bDXEa`,
	"paddingTop3": `ViewReceipt-paddingTop3-xzqAi`,
	"paddingTop4": `ViewReceipt-paddingTop4-Y0oWT`,
	"paddingTop5": `ViewReceipt-paddingTop5-fFmJK`,
	"paddingTop6": `ViewReceipt-paddingTop6-z124D`,
	"paddingTop7": `ViewReceipt-paddingTop7-nFLyr`,
	"noPadding": `ViewReceipt-noPadding-sXQG1`,
	"spaceMarginBottom0": `ViewReceipt-spaceMarginBottom0-hFsxv`,
	"textBold": `ViewReceipt-textBold-OC5qg`,
	"textBolder": `ViewReceipt-textBolder-i_1qg`,
	"textNormal": `ViewReceipt-textNormal-jQ7Id`,
	"textDarkBlue": `ViewReceipt-textDarkBlue-aPXlL`,
	"textLightBlue": `ViewReceipt-textLightBlue-HjCvg`,
	"textLightSandleGreen": `ViewReceipt-textLightSandleGreen-QmdjG`,
	"textLightBrown": `ViewReceipt-textLightBrown-iVPu6`,
	"textMediumMaroon": `ViewReceipt-textMediumMaroon-PslEo`,
	"textBrown": `ViewReceipt-textBrown-Mtbuq`,
	"textMaroon": `ViewReceipt-textMaroon-BkBYD`,
	"textDarkBrown": `ViewReceipt-textDarkBrown-yYMG4`,
	"textMediumBrown": `ViewReceipt-textMediumBrown-dsrO8`,
	"textSkyBlue": `ViewReceipt-textSkyBlue-NgJ9Y`,
	"textGray": `ViewReceipt-textGray-SgI4Q`,
	"errorMessage": `ViewReceipt-errorMessage-QgnSe`,
	"userText": `ViewReceipt-userText-YYRTu`,
	"panelHeader": `ViewReceipt-panelHeader-xFEeZ`,
	"exportSection": `ViewReceipt-exportSection-DKfKb`,
	"exportSectionGridSub": `ViewReceipt-exportSectionGridSub-gdu28`,
	"exportText": `ViewReceipt-exportText-Ed4Fm`,
	"exportLinkImg": `ViewReceipt-exportLinkImg-IjJNY`,
	"exportImg": `ViewReceipt-exportImg-Pk2gr`,
	"linkBtn": `ViewReceipt-linkBtn-OEmXa`,
	"table": `ViewReceipt-table-a2hBT`,
	"tableRow": `ViewReceipt-tableRow-OGJ3K`,
	"tableCell": `ViewReceipt-tableCell-C5a4R`,
	"formGroup": `ViewReceipt-formGroup-Om9TM`,
	"marginTop0": `ViewReceipt-marginTop0-eASki`,
	"marginBottom20": `ViewReceipt-marginBottom20-bGsT2`,
	"bannerImageBg": `ViewReceipt-bannerImageBg-EACVx`,
	"bannerDelete": `ViewReceipt-bannerDelete-pqr7L`,
	"exportLink": `ViewReceipt-exportLink-tO6zt`,
	"seachContent": `ViewReceipt-seachContent-_63mn`,
	"marginBottom9": `ViewReceipt-marginBottom9-QWU6w`,
	"spaceTop52": `ViewReceipt-spaceTop52-GdoGM`,
	"profileViewInner": `ViewReceipt-profileViewInner-Aw5fD`,
	"profileViewMain": `ViewReceipt-profileViewMain-hawGp`,
	"profileViewlabel": `ViewReceipt-profileViewlabel-Wu5G1`,
	"profileViewMainContent": `ViewReceipt-profileViewMainContent-rMIvn`,
	"reviewsFormStar": `ViewReceipt-reviewsFormStar-oxp2Y`,
	"addLanguageText": `ViewReceipt-addLanguageText-XXzPo`
};
module.exports = ___CSS_LOADER_EXPORT___;
